<template>
    <div>
        <div class="main_slider" >
            <div class="slider-container">
                <div class="slider-wrapper">
                    <a class="slider-slide"  :href="item.link" v-for="(item,key) in mainSlider" :key="key" :style="{'background-image': 'url(' + item.previewImg + ')'}">
                        <div class="wrapper">
                            <p :style="{'color':item.titleColor}">
                            {{item.previewText}}
                            <br v-if="item.detailText">
                            {{item.detailText}}
                            </p>
                            <button v-if="!item.hideButton" :style="{'color':item.buttonTextColor,'background-color':item.buttonBgColor}">
                                {{item.buttonText ? item.buttonText : 'Подробнее'}}
                            </button>
                        </div>
                    </a>
                </div>
                <!--<template v-if="mainSlider.length > 1">
                    <button class="slider-button prev"></button>
                    <button class="slider-button next">
                        <img src="@/assets/img/main_arrow.png" alt="вправо">
                    </button> 
                </template> -->
            </div>
        </div>

        <div class="over">
            <div class="first_slider wrapper" v-if="arBlocks[0].title">
                <div class="section_ttl">
                    <p>{{arBlocks[0].title}}</p>
                </div>
                <template  v-if="arBlocks[0].productsForSlider.length > 0">
                    <div class="item_slider">
                        <div class="fs_item fake" v-if="isMobile"></div>
                        <div class="fs_item" v-for="(product,key) in arBlocks[0].productsForSlider"  :key="key">
                            <a :href="product.LINK" :class="'inner_slider' + key">
                                <div class="is_item">
                                    <img :src="product.PROPERTY_MORE_PHOTO_VALUE" alt="">
                                </div>
                                <!-- Изначально были слайды для каждого товара в слайдере товаров. Потом решили отказаться от этого -->
                                <!-- <div class="is_item" v-for="(slide,key2) in product.PROPERTY_MORE_PHOTO_VALUE"  :key="key2">
                                    <img :src="'https://excelsior.fashion' + slide" alt="">
                                </div> -->
                            </a>
                            <!-- Изначально были слайды для каждого товара в слайдере товаров. Потом решили отказаться от этого -->
                            <!-- <div class="i_dots" :class="'i_glider_dots' + key"></div>   -->
                            <a :href="product.LINK" class="abs_name">
                                <p class="name">{{product.BRAND}}</p>                           
                            </a>         
                            <a :href="product.LINK" class="abs_type">
                                <p class="type">{{product.NAME}}</p>                           
                            </a>     
                        </div>
                        <div class="fs_item fake" v-if="isMobile"></div>     
                    </div>   
                    <button class="f_glider_prev arrow">
                        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            width="792px" height="792px" viewBox="0 0 792 792" style="enable-background:new 0 0 792 792;" xml:space="preserve">
                            <g>
                                <g>
                                    <polygon points="580.802,369.604 580.802,369.604 211.198,0 184.802,26.396 554.405,396 184.802,765.604 211.198,792 
                                        607.198,396 			"/>
                                </g>
                            </g>
                        </svg>
                        <!--<img src="@/assets/img/arrow.png" alt="влево"> -->
                    </button>
                    <button class="f_glider_next arrow">
                        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            width="792px" height="792px" viewBox="0 0 792 792" style="enable-background:new 0 0 792 792;" xml:space="preserve">
                            <g>
                                <g>
                                    <polygon points="580.802,369.604 580.802,369.604 211.198,0 184.802,26.396 554.405,396 184.802,765.604 211.198,792 
                                        607.198,396 			"/>
                                </g>
                            </g>
                        </svg>
                        <!--<img src="@/assets/img/arrow.png" alt="вправо">-->
                    </button>
                    <!-- <div class="f_glider_dots goods_dots" v-if="arBlocks[0].productsForSlider.length > 0"></div> -->
                </template>
            </div>
        </div>

        <a :href="arBlocks[1].link1"  v-if="arBlocks[1]">
            <div class="banner_block additional_banner" v-if="arBlocks[1].previewImg" :style="{'background-image': 'url(' + arBlocks[1].previewImg + ')'}">
                <div class="wrapper">
                    <p :style="{'color':arBlocks[1].textColor}">
                        {{arBlocks[1].previewText}}
                        <br v-if="arBlocks[1].detailText">
                        {{arBlocks[1].detailText}}
                    </p>
                    <button v-if="!arBlocks[1].hideButton" :style="{'color':arBlocks[1].buttonTextColor,'background-color':arBlocks[1].buttonBgColor}">
                        {{arBlocks[1].buttonText ? arBlocks[1].buttonText : 'Подробнее'}}
                    </button>
                </div>
            </div>
        </a>

        <div class="over">
            <div class="first_slider wrapper" v-if="arBlocks[2] && (arBlocks[2].productsForSlider.length > 0 || arBlocks[2].sectionsForSlider.length > 0)">
                <div class="section_ttl">
                    <p>{{arBlocks[2].title}}</p>
                </div>
                <template v-if="arBlocks[2].sectionsForSlider.length > 0">
                    <div class="item_slider2">
                        <div class="fs_item fake" v-if="isMobile"></div>
                        <div class="fs_item" v-for="(section,key) in arBlocks[2].sectionsForSlider" :key="key">
                            <a :href="section.LINK" :class="'pic_link inner_slider' + key">
                                <div class="is_item" :style="{ 'background-image': 'url(' + section.PICTURE + ')'}">
                                    <!--<img :src="'https://excelsior.fashion' + section.PICTURE" alt=""> -->
                                </div>
                            </a>
                            <a :href="section.LINK" class="abs_name">
                                <p class="name">{{section.NAME}}</p>                           
                            </a>
                        </div>
                        <div class="fs_item fake" v-if="isMobile"></div>       
                    </div>
                </template>
                <template v-else>
                    <div class="item_slider2" v-if="arBlocks[2].productsForSlider.length > 0">
                        <div class="fs_item" v-for="(product,key) in arBlocks[2].productsForSlider" :key="key">
                            <a :href="product.LINK" :class="'pic_link inner_slider' + key">
                                <div class="is_item">
                                    <img :src="product.PROPERTY_MORE_PHOTO_VALUE" alt="">
                                </div>
                            </a>
                            <a :href="product.LINK" class="abs_name">
                                <p class="name">{{product.BRAND}}</p>                           
                            </a>         
                            <a :href="product.LINK" class="abs_type">
                                <p class="type">{{product.NAME}}</p>                           
                            </a>     
                        </div>         
                    </div>
                </template>
                <button class="f_glider2_prev arrow">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        width="792px" height="792px" viewBox="0 0 792 792" style="enable-background:new 0 0 792 792;" xml:space="preserve">
                        <g>
                            <g>
                                <polygon points="580.802,369.604 580.802,369.604 211.198,0 184.802,26.396 554.405,396 184.802,765.604 211.198,792 
                                    607.198,396 			"/>
                            </g>
                        </g>
                    </svg>
                    <!-- <img src="@/assets/img/arrow.png" alt="влево"> -->
                </button>
                <button class="f_glider2_next arrow">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        width="792px" height="792px" viewBox="0 0 792 792" style="enable-background:new 0 0 792 792;" xml:space="preserve">
                        <g>
                            <g>
                                <polygon points="580.802,369.604 580.802,369.604 211.198,0 184.802,26.396 554.405,396 184.802,765.604 211.198,792 
                                    607.198,396 			"/>
                            </g>
                        </g>
                    </svg>
                    <!-- <img src="@/assets/img/arrow.png" alt="вправо"> -->
                </button>
                <!-- <div class="f_glider_dots goods_dots" v-if="arBlocks[2].productsForSlider.length > 0"></div> -->
            </div>
        </div>

        <a :href="arBlocks[3].link1" v-if="arBlocks[3].previewImg">
            <div class="banner_block" :style="{'background-image': 'url(' + arBlocks[3].previewImg + ')'}"></div>
        </a>

        <div class="half_blocks wrapper rev">            
            <div class="slide_block" v-if="arBlocks[4].productsForSlider.length > 0">
                <div class="half_slider2">
                    <div class="h_slide" v-for="(groupFour, i) in arBlocks[4].productsForSlider" :key="i">
                        <div class="h_flexer">
                            <a v-for="(product, j) in groupFour" :key="j" :href="product.LINK">
                                <img :src="'https://excelsior.fashion' + product.PROPERTY_MORE_PHOTO_VALUE" alt="">
                                <p class="name">{{product.BRAND}}</p>
                            </a>
                        </div>
                    </div>
                </div>
                <button class="h_glider_prev2 arrow">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        width="792px" height="792px" viewBox="0 0 792 792" style="enable-background:new 0 0 792 792;" xml:space="preserve">
                        <g>
                            <g>
                                <polygon points="580.802,369.604 580.802,369.604 211.198,0 184.802,26.396 554.405,396 184.802,765.604 211.198,792 
                                    607.198,396 			"/>
                            </g>
                        </g>
                    </svg>
                    <!--<img src="@/assets/img/arrow.png" alt="влево"> -->
                </button>
                <button class="h_glider_next2 arrow">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        width="792px" height="792px" viewBox="0 0 792 792" style="enable-background:new 0 0 792 792;" xml:space="preserve">
                        <g>
                            <g>
                                <polygon points="580.802,369.604 580.802,369.604 211.198,0 184.802,26.396 554.405,396 184.802,765.604 211.198,792 
                                    607.198,396 			"/>
                            </g>
                        </g>
                    </svg>
                    <!--<img src="@/assets/img/arrow.png" alt="вправо"> -->
                </button>
            </div>  
            <div class="section_block" :style="{'background-image': 'url(' + arBlocks[4].previewImg + ')'}">
                <a :href="arBlocks[4].link1" class="filler">
                    <span class="title">{{arBlocks[4].title}}</span>
                </a>
            </div>
        </div>

        <div class="boutique_block wrapper" v-if="arBlocks[5]">
            <div class="boutque_item">
                <a :href="arBlocks[5].link1" class="pic" :style="{'background-image': 'url(' + arBlocks[5].previewImg + ')'}"></a>  
                <a :href="arBlocks[5].link1" class="link">
                    <p>{{arBlocks[5].previewText}}</p>
                </a>              
            </div>
            <div class="boutque_item">
                <a :href="arBlocks[5].link2" class="pic" :style="{'background-image': 'url(' + arBlocks[5].detailImg + ')'}"></a>
                <a :href="arBlocks[5].link2" class="link">
                    <p>{{arBlocks[5].detailText}}</p>
                </a>
            </div>
        </div>
    </div>
</template>
<style src="@/assets/style/glider_home_page.css"></style>
<style src="@/assets/style/header.css"></style>
<!-- <style src="@/assets/style/home.scss" scoped lang="scss"></style> -->
<script>
// import '@/assets/style/header.css';
import { mapActions, mapGetters } from "vuex";
// import Instagram from '@/components/Blocks/Instagram'
// import Footer from '@/components/Footer'
// import Subscription from '../core/modules/subscription'
import News from '../core/modules/news'

export default {
  name: 'home',
  // components: { Instagram },
  data() {
    return {
        activeCategories: this.$parent.activeCategories,
      // email: null,
      // subscribe: {
      //   status: true,
      //   message: null
      // },
      isMobile: false,
    }
  },
  methods: {
    ...mapActions({
        fillBlocks: "banners/fill",
        fillSlider: "banners/fillSlider",
    }),
    mainSliderScript() {
        /*ГЛАВНАЯ КАРУСЕЛЬ*/
        let mainSliderScript = document.createElement('script');
        mainSliderScript.setAttribute('id', 'mainSliderScript');
        // если вдруг решат делать этот блок слайдером, то стоит попробовать убрать "window.addEventListener("DOMContentLoaded",function(){}"
        mainSliderScript.text = '\n\
            window.addEventListener("DOMContentLoaded",function(){\n\
              const sliderWrapper = document.querySelector(".slider-wrapper");\n\
              const sliderSlides = document.querySelectorAll(".slider-slide");\n\
              const prevButton = document.querySelector(".prev");\n\
              const nextButton = document.querySelector(".next");\n\
              const slideWidth = sliderSlides[0].offsetWidth;\n\
              const visibleSlides = Math.floor(sliderWrapper.offsetWidth / slideWidth);\n\
              let currentSlide = 0;\n\
              // Перемещение слайдов\n\
              function moveSlides(direction) {\n\
                if (direction === "prev") {\n\
                  currentSlide--;\n\
                  if (currentSlide < 0) {\n\
                    currentSlide = sliderSlides.length - visibleSlides;\n\
                  }\n\
                } else if (direction === "next") {\n\
                  currentSlide++;\n\
                  if (currentSlide > sliderSlides.length - visibleSlides) {\n\
                    currentSlide = 0;\n\
                  }\n\
                }\n\
                sliderWrapper.style.transform = `translateX(-${currentSlide * slideWidth}px)`;\n\
              }\n\
              // Обработчик нажатия на кнопки\n\
              // prevButton.addEventListener("click", () => moveSlides("prev"));\n\
              // nextButton.addEventListener("click", () => moveSlides("next"));\n\
            });';
        document.head.appendChild(mainSliderScript);
        /*ГЛАВНАЯ КАРУСЕЛЬ ВСЁ*/
    },
    slidersInSlider() {
        /* СЛАЙДЕРЫ В СЛАЙДЕРЕ*/
        if (this.arBlocks[0].productsForSlider.length > 0) {
            let slidersInSlider = document.createElement('script');
            slidersInSlider.setAttribute('id', 'sliderInSliderScript');
            slidersInSlider.text = `
                new Glider(document.querySelector('.item_slider'), {
                  // Mobile-first defaults
                  slidesToShow: 6,
                  slidesToScroll: 6,
                  draggable: true,
                  scrollLock: true,
                  dragVelocity: 1,
                  dots: '.f_glider_dots',
                  arrows: {
                      prev: '.f_glider_prev',
                      next: '.f_glider_next'        
                  },
                  responsive: [
                  {
                      breakpoint: 300,
                      settings: {
                          slidesToShow: 3,
                          slidesToScroll: 1,
                      }
                  },
                  {
                      breakpoint: 775,
                      settings: {
                          slidesToShow: 4,
                          slidesToScroll: 1,
                      }
                  },
                  {
                      breakpoint: 999,
                      settings: {
                          slidesToShow: 5,
                          slidesToScroll: 1,
                      }
                  },
                  {
                      breakpoint: 1280,
                      settings: {
                          slidesToShow: 6,
                          slidesToScroll: 1,
                      }
                  }
                  ]
                });`;

            let slidersInSlider2 = document.createElement('script');
            slidersInSlider2.setAttribute('id', 'sliderInSliderScript2');
            slidersInSlider2.text = `
            new Glider(document.querySelector('.item_slider2'), {
              // Mobile-second defaults
              slidesToShow: 6,
              slidesToScroll: 6,
              draggable: true,
              scrollLock: true,
              dragVelocity: 1,
              arrows: {
                  prev: '.f_glider2_prev',
                  next: '.f_glider2_next'        
              },
              responsive: [
              {
                  breakpoint: 300,
                  settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1,
                  }
              },
              {
                  breakpoint: 775,
                  settings: {
                      slidesToShow: 4,
                      slidesToScroll: 1,
                  }
              },
              {
                  breakpoint: 999,
                  settings: {
                      slidesToShow: 5,
                      slidesToScroll: 1,
                  }
              },
              {
                  breakpoint: 1380,
                  settings: {
                      slidesToShow: 6,
                      slidesToScroll: 6,
                  }
              }
              ]
            });`;

            document.head.appendChild(slidersInSlider);
            document.head.appendChild(slidersInSlider2);
        }

        /* СЛАЙДЕРЫ В СЛАЙДЕРЕ ВСЁ*/
    },
    sliderBy4piece() {
        if (this.arBlocks[4].productsForSlider.length > 0) {
            let sliderBy4piece = document.createElement('script');
            sliderBy4piece.setAttribute('id', 'sliderBy4piece');
            sliderBy4piece.text = `
                new Glider(document.querySelector('.half_slider2'), {
                slidesToShow: 1,
                slidesToScroll: 1,
                draggable: true,
                scrollLock: true,
                dragVelocity: 1,
                arrows: {
                    prev: '.h_glider_prev2',
                    next: '.h_glider_next2'  
                }
            });`;
            document.head.appendChild(sliderBy4piece);
        }
    },
  //   subscribeNewsletter (email) {
  //     Subscription.subscribe(email).then((response) => {
  //       if (response.message) {
  //         this.subscribe.status = response.status
  //         this.subscribe.message = response.message
  //       }
  //     })
  //   }
  },
  computed: {
      ...mapGetters({
          arBlocks: "banners/getBanners",
          mainSlider: "banners/getSlides"
      }),

      // isMobile() {
      //   let deviceDetect = new MobileDetect(window.navigator.userAgent);
      //   return deviceDetect.mobile() ? true : false;
      // }
  },
  beforeMount() {
    let deviceDetect = new MobileDetect(window.navigator.userAgent);
    this.isMobile = deviceDetect.mobile() ? true : false;
  },
  mounted() {
    if (localStorage.getItem('currentRootSection')) {
        this.currentRootSection = localStorage.getItem('currentRootSection');
    }
    
    if(!this.arBlocks) {
      this.fillBlocks(this.activeCategories.currentRootSection);
    }

    if(!this.mainSlider) {
      this.fillSlider(this.activeCategories.currentRootSection);
    }

    // отфильтровывание контент для М и Ж. Контент, в котором нет отметки для кого показывать, отображается для всех. Это происходит на бекенде

    
    /*ГЛАВНАЯ КАРУСЕЛЬ*/
    /*сейчас просто баннер, пока что*/
    if (Array.isArray(this.mainSlider) && this.mainSlider.length > 1)
        this.mainSliderScript();
    /*ГЛАВНАЯ КАРУСЕЛЬ ВСЁ*/

    /* СЛАЙДЕРЫ В СЛАЙДЕРЕ*/
    this.slidersInSlider();
    /* СЛАЙДЕРЫ В СЛАЙДЕРЕ ВСЁ*/

    /*СЛАЙДЕР ПО 4 ТОВРА*/
    this.sliderBy4piece();
    /*СЛАЙДЕР ПО 4 ТОВРА ВСЁ*/
  },
  serverPrefetch(){
    this.fillSlider(this.activeCategories.currentRootSection);
    return this.fillBlocks(this.activeCategories.currentRootSection)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue